import { render, staticRenderFns } from "./ubruCoffeeView.vue?vue&type=template&id=2ee7473d"
import script from "./ubruCoffeeView.vue?vue&type=script&lang=js"
export * from "./ubruCoffeeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports